export const SEPOLIA_CHAIN_ID = 11155111;

/** Default HTTP Sepolia RPC (browser-friendly; avoid rpc.sepolia.org — often slow/CORS issues). */
export const SEPOLIA_RPC_URL =
  process.env.REACT_APP_SEPOLIA_RPC_URL ||
  "https://ethereum-sepolia.publicnode.com";

export const CONTRACTS = {
  sportfolioIPO: "0xF8828Fc2E504882C21BA6EcC116CcF87e2824B8a",
  usdc: "0xBe3E498474617Ff9dfB2a191B629CB680769E66b",
};

